var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.modeEdit)?_c('tt-editor',{attrs:{"value":_vm.data},on:{"input":_vm.changeText}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }